import { call, put, takeLatest } from "@redux-saga/core/effects";
import { LeadsApi } from "./LeadsApi";
import { LeadsDataConstant } from "./LeadsContant";
import { LeadsParser } from "./LeadsParser";

function* getLeadsData({payload}) {
    let {  from_date, to_date ,search_term,page,limit} = payload;
  try {
    yield put({ type: LeadsDataConstant.LEADS_DATA_REQUEST });

    const res = yield call(LeadsApi.getLeadsData,{from_date, to_date,search_term,page,limit });

    const payload = LeadsParser.getLeadsParser(res);

    yield put({
      type: LeadsDataConstant.LEADS_DATA_RESPONSE,
      payload: payload,
    });
  } catch (e) {
    console.log("Error", e);
    yield put({
      type: LeadsDataConstant.LEADS_DATA_RESPONSE,
      payload: [],
    });
  }
}
export function* registergetLeadsSaga() {
    yield takeLatest(
        LeadsDataConstant.LEADS_DATA_SAGA,
      getLeadsData
    )}